import React from "react";
import Input from "../input/input";
import './technicalSkill.scss';
let self;

export class TechnicalSkill extends React.Component<any, any> {
    skillForm = { skillType: '', skillsList: [] };
    defaultSkill = {name:'',rating:''}
    constructor(props: any) {
        super(props);
        self = this;
        this.state = { skillForm: this.skillForm, noOfSkillsType: 1, technologies: {},skillsList:[{name:'',rating:''}], skill:this.defaultSkill }
        // this.send = this.send.bind(this);
    }

    send(event, isNext) {
        event.preventDefault();
        const newSkillForm = {...self.state.skillForm, skillsList: [...self.state.skillForm.skillsList, self.state.skill]}
        self.setState({ skillForm: newSkillForm });
        self.setState({ skill: self.defaultSkill});
        // console.log('skillForm',this.state)
        self.props.onTechnicalSkillAdded(newSkillForm, isNext)
    }

    onInputChange(data, field) {
        self.setState((prevState) => ({
            skillForm: { ...prevState.skillForm, [field]: data }
        }))
    }

    onSkillChanges(data, field) {
        self.setState((prevState) => ({
            skill: { ...prevState.skill, [field]: data }
        }))
    }
    handleRatingChange(event, fieldName) {
        // console.log(event.target.value, fieldName)
        // self.setState((prevState) => ({
        //     skill: { ...prevState.skill, [field]: data }
        // }))
        self.onSkillChanges(event.target.value,fieldName)
    }
    add(event) {
        event.preventDefault();
        self.setState({ noOfSkillsType: self.state.noOfSkillsType+1 });
        self.setState({ skillForm: {...self.state.skillForm, skillsList: [...self.state.skillForm.skillsList, self.state.skill]} });
        self.setState({ skill: self.defaultSkill});
        // console.log(this.state)
    }

    render(): React.ReactNode {
        return (
            <div className="form__wrapper">
                <h4>Enter Technical Skill - {this.props.skillNo}</h4>
                <form className="form__item">
                    <Input placeHolder='Enter  Technical Skill Type eg.(FRAMEWORKS.. etc)' type='text' key={1} value="" maxLength="100" minLength="1" name="skillType" onInputChange={this.onInputChange}></Input>
                    {
                        <>
                            {Array.from({ length: this.state.noOfSkillsType }).map((e, i) => {
                                return (
                                    <div className="technical-skill__type" key={i}>
                                        <Input placeHolder={`Enter Skill ${i + 1}`} type='text' name='name' key={i} value="" onInputChange={this.onSkillChanges}></Input>
                                        <select className="technical-skill__dropdown" onChange={(event) => this.handleRatingChange(event, 'rating')}>
                                            <option>Select Rating</option>
                                            <option value={1}>1</option>
                                            <option value={2}>2</option>
                                            <option value={3}>3</option>
                                            <option value={4}>4</option>
                                            <option value={5}>5</option>
                                            <option value={6}>6</option>
                                            <option value={7}>7</option>
                                            <option value={8}>8</option>
                                            <option value={9}>9</option>
                                            <option value={10}>10</option>
                                        </select>
                                        <button  className="technical-skill__btn"  disabled={!this.state.skill.name || !this.state.skill.rating} onClick={(e)=> this.add(e)}>Add</button>
                                    </div>
                                )
                            })}
                        </>
                    }
                    {
                        this.state.noOfSkillsType>0 &&
                        <>
                        <button className="app-btn" onClick={(e)=> this.send(e,false)}>Done?</button>
                        <button className="app-btn" onClick={(e)=> this.send(e,true)}>Want to Add more Project ?</button>
                        </>
                    }
                </form>
            </div>
        )
    }
}

export default TechnicalSkill;